import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=5dae6be0&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=5dae6be0&scoped=true&lang=css&"
import style1 from "./ChatBot.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae6be0",
  null
  
)

export default component.exports